module.exports = __webpack_public_path__ + "static/index/img/baikal-202.a9a2f107.jpg";